/*** IMPORTS FROM imports-loader ***/
var define = false;





//////////////////
// WEBPACK FOOTER
// C:/Build/cc0baf4df369d6e0/~/node-libs-browser/mock/empty.js
// module id = 373
// module chunks = 49